import { COMMON__Home, COMMON__My_favorite_translations, COMMON__My_space, COMMON__Recently_viewed_translations, } from '@app/services/i18n.messages';
import { getMessage } from '@app/services/i18n.service';
import { derived, writable } from 'svelte/store';
const breadcrumbsWritable = writable([]);
export const setBreadcrumbs = (items) => {
    breadcrumbsWritable.set(items);
};
export const breadcrumbs = derived(breadcrumbsWritable, $breadcrumbItems => $breadcrumbItems);
export function homeBreadcrumbItem() {
    return {
        text: getMessage(COMMON__Home),
        link: "/",
    };
}
export function myGlosbeBreadcrumbItem() {
    return {
        text: getMessage(COMMON__My_space),
        link: "/user"
    };
}
export function myFavoriteTranslationsBreadcrumbItem() {
    return {
        text: getMessage(COMMON__My_favorite_translations),
        link: "/user/favoriteTranslations"
    };
}
export function myRecentlyViewedTranslationsBreadcrumbItem() {
    return {
        text: getMessage(COMMON__Recently_viewed_translations),
        link: "/user/recentlyViewed"
    };
}
